import { filter } from "lodash"
import { createSelector } from "reselect"
import { getDefaultCurrencyId } from "modules/account-root/selectors"
import { getSupportedCurrencies } from "resources/currencies"

export const getAvailableCurrencyOptions = createSelector(
  [getSupportedCurrencies, getDefaultCurrencyId],
  (supportedCurrencies, defaultAccountCurrencyId) => {
    const currencyFilter = defaultAccountCurrencyId ? (c) => c.id !== defaultAccountCurrencyId : (c) => !c.isDefault
    return filter(supportedCurrencies, currencyFilter)
  },
)
